import { DEBUG_MODE } from '../../spdConfig';

class MDCTEAudioDecoder {
  public static calculateAudioDuration(audioData: DataView): number {
    const view = audioData;
    let offset = 0;
    let frameCount = 0;

    while (offset < audioData.byteLength) {
      // Read header byte
      const header = view.getUint8(offset);
      offset += 1; // Move past header byte

      // Decode frame parameters from header
      const Bits_Encoded_Len = (header & 0b1) === 0 ? 4 : 5;
      const Error_factor_len = (header >> 1) & 0b11;

      // Calculate the length in bits of the encoded section and error vector
      const bitsEncoded = 16 * Bits_Encoded_Len;
      const errorVectorBits = 16 * Error_factor_len;
      const transformDataBits = bitsEncoded; // Assume transformData matches encoded bits

      // Calculate the total frame size in bits
      const frameBits =
        8 + bitsEncoded + 4 + transformDataBits + errorVectorBits;

      // Convert bits to bytes, rounding up
      const frameBytes = Math.ceil(frameBits / 8);

      // Move to next frame
      offset += frameBytes;
      frameCount++;
    }

    return frameCount;
  }
}

export class AudioHandler {
  protected buffers: ArrayBuffer[] = [];
  protected frameCount = 0;
  protected duration: number | null = null;
  protected fnProcessAudio: (() => Promise<void>) | null = null;

  public async getAudioRecording() {
    const appendBuffer = function (buffer1: ArrayBuffer, buffer2: ArrayBuffer) {
      const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
      tmp.set(new Uint8Array(buffer1), 0);
      tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
      return tmp.buffer;
    };
    // Combine all buffers
    let audioData: ArrayBuffer = this.buffers[0];
    const len = this.buffers.length;

    for (let j = 1; j < len; j++) {
      audioData = appendBuffer(audioData, this.buffers[j]);
    }

    DEBUG_MODE &&
      console.log(
        'getAudioRecording',
        audioData,
        this.frameCount,
        this.frameCount * 2.3,
      );

    return audioData;
  }

  public restartAudio() {
    this.buffers = [];
    this.frameCount = 0;
    this.duration = null;
    this.fnProcessAudio = null;
  }

  protected arrayBufferToBase64(buffer: ArrayBuffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return binary;
  }

  public setStopRecording(
    duration: number,
    fnProcessAudio: () => Promise<void>,
  ) {
    this.duration = duration;
    this.fnProcessAudio = fnProcessAudio;
  }

  private static toArrayBuffer(buf: ArrayBufferLike): ArrayBuffer {
    if (buf instanceof ArrayBuffer) {
      return buf;
    }
    // SharedArrayBuffer -> skopiuj do zwykłego ArrayBuffer
    const out = new ArrayBuffer(buf.byteLength);
    new Uint8Array(out).set(new Uint8Array(buf));
    return out;
  }

  public async onAudio(event: Event) {
    const characteristic = event.target as BluetoothRemoteGATTCharacteristic;
    const value = characteristic.value;

    if (value) {
      this.frameCount += MDCTEAudioDecoder.calculateAudioDuration(value);
      this.buffers.push(AudioHandler.toArrayBuffer(value.buffer));
      if (
        this.duration &&
        this.duration <= this.frameCount * 2.3 &&
        this.fnProcessAudio
      ) {
        const fn = this.fnProcessAudio;
        this.fnProcessAudio = null; ///wołamy tylko raz
        await fn();
      }
    }
  }
}
